import { IUser } from "../../../../../context/interfaces/User";
import { ITeam } from "../../../interfaces/team.interface";

export const defineRight = (user: IUser, team: ITeam | null): string | null => {
  if (!user || !Array.isArray(user.roles) || !team) return null;
  const found = user.roles.find((role) => role.team.id === team.id);
  return found?.right || null;
};
